import React from 'react'
import PropTypes from 'prop-types'

// Helpers
import { date } from 'helpers/format'

// Models
import Payment from 'models/Payment'

// Components
import Text from 'ui/Text'

export default function ColumnPostingDate({ row }) {
  const day = date(row.createdAt, 'dd')
  const month = date(row.createdAt, 'MMM')
  const year = date(row.createdAt, 'yyyy')

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#f5f8ff',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        padding: '0 10px',
      }}
    >
      <Text size={12} color="#000000" paddingTop={5} paddingBottom={10}>
        Posted
      </Text>
      <div
        style={{
          width: '54px',
          height: '54px',
          borderRadius: '50%',
          backgroundColor: '#ecf0fa',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: '17px',
        }}
      >
        <Text bold size={10} color="#020202">
          {month}
        </Text>
        <Text bold size={26} color="#020202">
          {day}
        </Text>
      </div>
      <Text size={10} paddingTop={16} paddingBottom={8}>
        {year}
      </Text>
    </div>
  )
}

ColumnPostingDate.propTypes = {
  row: PropTypes.instanceOf(Payment),
}

ColumnPostingDate.defaultProps = {
  row: new Payment(),
}
